// extracted by extract-css-chunks-webpack-plugin
module.exports = {"panel":"styles__panel___3GDp_","regenerate-statements":"styles__regenerate-statements___1CclU","regenerateStatements":"styles__regenerate-statements___1CclU","delete-button":"styles__delete-button___3oiFQ","deleteButton":"styles__delete-button___3oiFQ"};
    if(module.hot) {
      // 1770085638949
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  